import { useTranslation } from 'react-i18next'
import React from 'react'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import Input from 'components/p5/Input'
import useDeclarationFieldRequirements
  from 'features/declaration/form/components/useDeclarationFieldRequirements'

const scope = 'placeOfAcceptance'
function PlaceOfAcceptance() {
  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const fieldRequirements = useDeclarationFieldRequirements<TransitOperationFormValues>('transitOperation', [
    'placeOfAcceptance',
    'placeOfAcceptance.country',
    'placeOfAcceptance.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-acceptance-place"
        headingLabel={t('declaration.p5.placeOfAcceptance')}
        fieldRule={fieldRequirements.placeOfAcceptance}
      >
        <FormField
          labelKey="declaration.p5.nationality"
          fieldRule={fieldRequirements['placeOfAcceptance.country']}
        >
          <FormSelect
            <TransitOperationFormValues>
            field={`${scope}.country`}
            labelKey="declaration.p5.nationality"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements['placeOfAcceptance.country']}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.placeOfAcceptanceLocation"
          fieldRule={fieldRequirements['placeOfAcceptance.location']}
        >
          <Input
            <TransitOperationFormValues>
            field={`${scope}.location`}
            labelKey="declaration.p5.placeOfAcceptanceLocation"
            type="text"
            maxLength={35}
            placeholder={t('declaration.p5.placeOfAcceptanceLocation')}
            fieldRule={fieldRequirements['placeOfAcceptance.location']}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfAcceptance
